import { render, staticRenderFns } from "./ElementCreate.vue?vue&type=template&id=37a70902"
import script from "./ElementCreate.vue?vue&type=script&lang=ts"
export * from "./ElementCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports